import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import UploadPage from "@/pages/Upload";
import Analysis from "@/pages/Analysis";
import Documents from "@/pages/Documents";
import PreSignature from "@/pages/PreSignature";
import PreSignatureDetail from "@/pages/PreSignatureDetail";
import Trash from "@/pages/Trash";
import Activity from "@/pages/Activity";
import Workspaces from "@/pages/Workspaces";
import ComparisonDetail from "@/pages/ComparisonDetail";
import CrossCheck from "@/pages/CrossCheck";
import DecisionDetail from "@/pages/DecisionDetail";
import InvitationAccept from "@/pages/InvitationAccept";
import ResetPassword from "@/pages/ResetPassword";
import ConfirmEmail from "@/pages/ConfirmEmail";
import VerifyEmail from "@/pages/VerifyEmail";
import ManualFinancials from "@/pages/ManualFinancials";
import Alerts from "@/pages/Alerts";
import Chat from "@/pages/Chat";
import Lineage from "@/pages/Lineage";
import UnderWatch from "@/pages/UnderWatch";
import ExecutiveReport from "@/pages/ExecutiveReport";
import VigilanceReports from "@/pages/VigilanceReports";
import InvoicesSummary from "@/pages/InvoicesSummary";
import ManualInvoice from "@/pages/ManualInvoice";
import SettingsNotifications from "@/pages/SettingsNotifications";
import SettingsSecurity from "@/pages/SettingsSecurity";
import SettingsProfile from "@/pages/SettingsProfile";
import Pricing from "@/pages/Pricing";
import Admin from "@/pages/Admin";
import Home from "@/pages/Home";
import Help from "@/pages/Help";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import EnrollTwoFactor from "@/pages/EnrollTwoFactor";
import AppLayout from "@/components/AppLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/lib/AuthContext";
import { WorkspaceProvider } from "@/lib/WorkspaceContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <WorkspaceProvider>
          <BrowserRouter>
            <Toaster richColors position="bottom-right" />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/legal/terms" element={<Terms />} />
              <Route path="/legal/privacy" element={<Privacy />} />
              <Route path="/login" element={<Login />} />
              <Route path="/pricing" element={<Pricing />} />
              {/* Tokenized public links: the token now travels in the URL
                  fragment (#token=...) so it never reaches server logs nor
                  Umami. The :token path-param variants stay for links sent
                  in older emails. */}
              <Route path="/invitations" element={<InvitationAccept />} />
              <Route path="/invitations/:token" element={<InvitationAccept />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/confirm-email" element={<ConfirmEmail />} />
              <Route path="/confirm-email/:token" element={<ConfirmEmail />} />
              <Route path="/verify-email/:token" element={<VerifyEmail />} />

              <Route
                path="/enroll-2fa"
                element={
                  <ProtectedRoute>
                    <EnrollTwoFactor />
                  </ProtectedRoute>
                }
              />

              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/upload" element={<UploadPage />} />
                <Route path="/financials/manual" element={<ManualFinancials />} />
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/chat" element={<Chat />} />
                <Route path="/lineage/:chain_root_id" element={<Lineage />} />
                <Route path="/alerts/register" element={<UnderWatch />} />
                <Route path="/reports/executive" element={<ExecutiveReport />} />
                <Route path="/reports/vigilance" element={<VigilanceReports />} />
                <Route path="/invoices/summary" element={<InvoicesSummary />} />
                <Route path="/invoices/new" element={<ManualInvoice />} />
                <Route path="/documents" element={<Documents />} />
                <Route path="/pre-signature" element={<PreSignature />} />
                <Route path="/pre-signature/:id" element={<PreSignatureDetail />} />
                <Route path="/trash" element={<Trash />} />
                <Route path="/activity" element={<Activity />} />
                <Route path="/workspaces" element={<Workspaces />} />
                <Route path="/settings/notifications" element={<SettingsNotifications />} />
                <Route path="/settings/security" element={<SettingsSecurity />} />
                <Route path="/settings/profile" element={<SettingsProfile />} />
                <Route path="/aide" element={<Help />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/analysis/:id" element={<Analysis />} />
                <Route path="/comparisons" element={<CrossCheck />} />
                <Route path="/comparisons/:id" element={<ComparisonDetail />} />
                <Route path="/decisions/:id" element={<DecisionDetail />} />
              </Route>

              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
        </WorkspaceProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
